import ARGameContent from '@/component/ARGame/ARGameContent';
import RingSpinner from '@/component/common/Spinner/RingSpinner';
import { useAppDispatch, useAppSelector } from '@/hooks/redux';
import { getGameAction } from '@/redux/action/game';
import { useEffect } from 'react';

type ARGameContainerProps = {
  gameId: string;
  customDomain?: string;
};

const ARGameContainer = ({ gameId, customDomain }: ARGameContainerProps) => {
  const { game, isGameGetPending, error } = useAppSelector(state => state.game);
  const dispatch = useAppDispatch();

  const onGetGame = () => {
    dispatch(getGameAction(gameId));
  };
  useEffect(() => {
    onGetGame();
  }, []);
  if (error) return <div className="h4-thin flex justify-center">{error}</div>;
  if (isGameGetPending) return <RingSpinner isLoading={isGameGetPending} />;
  if (isGameGetPending == false && game)
    return <ARGameContent game={game} customDomain={customDomain} />;
};

export default ARGameContainer;
